// Centralised FAQ + legal page content for FitAgenda CH.
// Keep this file as the single source of truth for legal copy so a lawyer can review
// the texts easily without touching the React components.

export const FAQS = {
  it: [
    {
      q: "Come funziona il pagamento TWINT?",
      a: "Quando prenoti un corso, vieni reindirizzato a un checkout sicuro Stripe dove puoi pagare con TWINT in CHF. Conferma il pagamento dall'app TWINT del tuo smartphone: la prenotazione viene confermata immediatamente e ricevi una ricevuta digitale via email.",
    },
    {
      q: "Posso ottenere un rimborso?",
      a: "Sì. Se l'istruttore annulla il corso, ricevi automaticamente un rimborso completo. Se l'istruttore non si presenta o il corso non rispetta lo standard atteso, hai 48 ore dalla fine del corso per aprire una segnalazione tramite \"Le mie prenotazioni\". La nostra amministrazione verifica e procede con il rimborso (totale o parziale) entro 5 giorni lavorativi.",
    },
    {
      q: "Cosa succede se devo cancellare la mia prenotazione?",
      a: "Le politiche di cancellazione lato cliente sono attualmente al vaglio: per la beta, puoi contattare direttamente l'istruttore tramite la sezione \"Le mie prenotazioni\". Stiamo lavorando a un sistema automatizzato con regole chiare (es. rimborso al 100% fino a 24h prima del corso).",
    },
    {
      q: "Come vengono verificati gli istruttori?",
      a: "Ogni istruttore deve registrarsi con dati reali, bio professionale e certificazioni. La nostra amministrazione verifica manualmente ogni profilo prima dell'approvazione. Inoltre, ogni singolo corso pubblicato passa una rapida revisione di qualità.",
    },
    {
      q: "Quanto trattiene la piattaforma?",
      a: "FitAgenda CH applica una commissione del 10% su ogni prenotazione confermata. Il 90% del prezzo va direttamente all'istruttore. Trasparenza totale: i numeri sono visibili anche durante il checkout.",
    },
    {
      q: "I miei dati sono al sicuro?",
      a: "Sì. I dati sono trattati nel rispetto della Legge svizzera sulla protezione dei dati (nLPD/FADP) e del GDPR. Utilizziamo connessioni cifrate HTTPS, password hashate con bcrypt e i pagamenti sono gestiti da Stripe (PCI DSS Level 1). Vedi la nostra Privacy Policy per i dettagli.",
    },
    {
      q: "Posso lasciare una recensione anonima?",
      a: "No. Le recensioni sono firmate con il tuo nome (visibile) per garantire autenticità e contrastare recensioni false. Puoi recensire solo i corsi che hai effettivamente prenotato e completato.",
    },
    {
      q: "L'app è disponibile in altre lingue?",
      a: "FitAgenda CH è disponibile in italiano, tedesco e francese, per coprire tutta la Svizzera.",
    },
  ],
  de: [
    {
      q: "Wie funktioniert die TWINT-Zahlung?",
      a: "Bei der Kursbuchung wirst du zu einem sicheren Stripe-Checkout weitergeleitet, wo du mit TWINT in CHF bezahlen kannst. Bestätige die Zahlung in deiner TWINT-App: Die Buchung wird sofort bestätigt und du erhältst eine digitale Quittung per E-Mail.",
    },
    {
      q: "Kann ich eine Rückerstattung erhalten?",
      a: "Ja. Wenn der Trainer den Kurs absagt, erhältst du automatisch eine vollständige Rückerstattung. Wenn der Trainer nicht erscheint oder der Kurs nicht den erwarteten Standard erfüllt, hast du 48 Stunden nach Kursende, um eine Meldung über \"Meine Buchungen\" zu öffnen. Unsere Administration prüft und veranlasst die Erstattung (ganz oder teilweise) innerhalb von 5 Werktagen.",
    },
    {
      q: "Was passiert, wenn ich meine Buchung stornieren muss?",
      a: "Die Stornierungsrichtlinien für Kunden werden derzeit geprüft: Für die Beta kontaktierst du den Trainer direkt über \"Meine Buchungen\". Wir arbeiten an einem automatisierten System mit klaren Regeln (z.B. 100% Rückerstattung bis 24h vor dem Kurs).",
    },
    {
      q: "Wie werden Trainer überprüft?",
      a: "Jeder Trainer muss sich mit echten Daten, beruflicher Bio und Zertifikaten registrieren. Unsere Administration prüft jedes Profil manuell vor der Freigabe. Zusätzlich durchläuft jeder veröffentlichte Kurs eine schnelle Qualitätsprüfung.",
    },
    {
      q: "Wie viel behält die Plattform ein?",
      a: "FitAgenda CH erhebt 10% Provision auf jede bestätigte Buchung. 90% des Preises gehen direkt an den Trainer. Volle Transparenz: Die Zahlen sind auch beim Checkout sichtbar.",
    },
    {
      q: "Sind meine Daten sicher?",
      a: "Ja. Die Daten werden gemäss dem Schweizer Datenschutzgesetz (nDSG/FADP) und der DSGVO verarbeitet. Wir verwenden verschlüsselte HTTPS-Verbindungen, mit bcrypt gehashte Passwörter und Zahlungen werden von Stripe (PCI DSS Level 1) abgewickelt. Details in unserer Datenschutzerklärung.",
    },
    {
      q: "Kann ich anonym bewerten?",
      a: "Nein. Bewertungen werden mit deinem (sichtbaren) Namen signiert, um Authentizität zu gewährleisten und Fake-Bewertungen zu verhindern. Du kannst nur Kurse bewerten, die du tatsächlich gebucht und besucht hast.",
    },
    {
      q: "Ist die App in weiteren Sprachen verfügbar?",
      a: "Derzeit ist FitAgenda CH auf Italienisch, Deutsch und Französisch verfügbar, um die gesamte Schweiz abzudecken.",
    },
  ],
  fr: [
    {
      q: "Comment fonctionne le paiement TWINT ?",
      a: "Lors de la réservation d'un cours, tu es redirigé vers un checkout sécurisé Stripe où tu peux payer avec TWINT en CHF. Confirme le paiement dans l'app TWINT de ton smartphone : la réservation est confirmée immédiatement et tu reçois un reçu numérique par e-mail.",
    },
    {
      q: "Puis-je obtenir un remboursement ?",
      a: "Oui. Si le coach annule le cours, tu reçois automatiquement un remboursement intégral. Si le coach ne se présente pas ou si le cours ne répond pas au standard attendu, tu disposes de 48 heures après la fin du cours pour ouvrir un signalement via \"Mes réservations\". Notre administration vérifie et procède au remboursement (total ou partiel) dans un délai de 5 jours ouvrés.",
    },
    {
      q: "Que se passe-t-il si je dois annuler ma réservation ?",
      a: "Les conditions d'annulation côté client sont en cours de finalisation : pour la bêta, contacte directement le coach via \"Mes réservations\". Nous travaillons à un système automatisé avec des règles claires (par ex. remboursement à 100% jusqu'à 24h avant le cours).",
    },
    {
      q: "Comment les coachs sont-ils vérifiés ?",
      a: "Chaque coach doit s'inscrire avec des données réelles, une bio professionnelle et ses certifications. Notre administration vérifie manuellement chaque profil avant validation. De plus, chaque cours publié passe une rapide revue qualité.",
    },
    {
      q: "Quelle est la commission de la plateforme ?",
      a: "FitAgenda CH applique une commission de 10% sur chaque réservation confirmée. 90% du prix vont directement au coach. Transparence totale : les chiffres sont également visibles lors du checkout.",
    },
    {
      q: "Mes données sont-elles en sécurité ?",
      a: "Oui. Les données sont traitées conformément à la Loi suisse sur la protection des données (LPD/FADP) et au RGPD. Nous utilisons des connexions chiffrées HTTPS, des mots de passe hachés avec bcrypt et les paiements sont gérés par Stripe (PCI DSS Level 1). Voir notre Politique de confidentialité pour les détails.",
    },
    {
      q: "Puis-je laisser un avis anonyme ?",
      a: "Non. Les avis sont signés avec ton nom (visible) afin de garantir l'authenticité et de lutter contre les faux avis. Tu peux uniquement évaluer les cours que tu as effectivement réservés et suivis.",
    },
    {
      q: "L'app est-elle disponible dans d'autres langues ?",
      a: "FitAgenda CH est actuellement disponible en italien, allemand et français, pour couvrir toute la Suisse.",
    },
  ],
};

// ----------------------------------------------------------------------------
// IMPORTANT — these legal templates cover the essentials of Swiss nLPD/FADP and
// EU GDPR for an MVP. Before serving real users, have these reviewed by a Swiss
// lawyer (or a service like Swiss Legal Tech / Datenschutzpartner.ch).
// ----------------------------------------------------------------------------

export const LEGAL_PAGES = {
  it: {
    terms: {
      title: "Termini e Condizioni",
      updated: "Ultimo aggiornamento: Febbraio 2026",
      sections: [
        {
          h: "1. Oggetto del servizio",
          p: "FitAgenda CH (di seguito \"la Piattaforma\") è un marketplace digitale che mette in contatto clienti (di seguito \"Utenti\") con istruttori fitness indipendenti (di seguito \"Istruttori\") attivi sul territorio svizzero. La Piattaforma agisce esclusivamente come intermediario tecnologico e non eroga direttamente alcun servizio sportivo, di allenamento o medico.",
        },
        {
          h: "2. Natura del rapporto contrattuale",
          p: "Il contratto di prestazione del servizio fitness si instaura direttamente tra l'Utente e l'Istruttore. La Piattaforma non è parte di tale contratto e non assume alcuna responsabilità per la qualità, la sicurezza, l'idoneità o l'esito delle sessioni di allenamento. Ogni Istruttore è responsabile in proprio del rispetto delle normative svizzere applicabili (autorizzazioni, assicurazioni di responsabilità civile professionale, normative cantonali e federali in materia sportiva e sanitaria).",
        },
        {
          h: "3. Pagamenti e commissioni",
          p: "I pagamenti avvengono tramite Stripe (con metodo TWINT) in franchi svizzeri (CHF). La Piattaforma trattiene una commissione del 10% sul prezzo lordo di ogni prenotazione; il restante 90% è riconosciuto all'Istruttore. Le fatture commerciali tra Utente e Istruttore restano di esclusiva responsabilità dell'Istruttore (incluso l'eventuale assoggettamento IVA se sopra la soglia di CHF 100'000 annui ex art. 10 LIVA).",
        },
        {
          h: "4. Annullamenti, rimborsi e dispute",
          p: "Annullamenti effettuati dall'Istruttore prima dell'inizio del corso comportano il rimborso integrale all'Utente. L'Utente può segnalare problemi (mancata presenza dell'Istruttore, qualità insufficiente, luogo errato) entro 48 ore dalla fine del corso tramite l'apposita funzione. L'amministrazione della Piattaforma valuta la segnalazione e può disporre un rimborso totale o parziale a sua discrezione. La decisione della Piattaforma è insindacabile in via amministrativa, fatto salvo il ricorso alle vie ordinarie.",
        },
        {
          h: "5. Recensioni e contenuti utente",
          p: "Le recensioni devono essere veritiere e basate su un'esperienza diretta. Recensioni diffamatorie, false o discriminatorie possono essere rimosse senza preavviso. L'Istruttore può richiedere alla Piattaforma di rimuovere una recensione manifestamente illecita. La Piattaforma non si fa garante della veridicità dei contenuti pubblicati dagli Istruttori (descrizioni dei corsi, bio, certificazioni dichiarate).",
        },
        {
          h: "6. Limitazione di responsabilità",
          p: "Nella misura massima consentita dalla legge svizzera, la Piattaforma esclude qualsiasi responsabilità per: (a) infortuni o danni fisici o materiali occorsi durante o in conseguenza dei corsi prenotati; (b) condotta o omissioni degli Istruttori; (c) idoneità medica dell'Utente alla pratica sportiva (è responsabilità dell'Utente consultare un medico prima di iniziare un programma di attività fisica); (d) interruzioni temporanee del servizio, malfunzionamenti dei sistemi di pagamento, perdita di dati per cause di forza maggiore. La responsabilità per dolo o colpa grave non è limitabile ai sensi dell'art. 100 CO.",
        },
        {
          h: "7. Modifiche e cessazione",
          p: "La Piattaforma può modificare i presenti termini in qualsiasi momento, comunicando la modifica via email o tramite avviso in app. La continuazione dell'utilizzo del servizio costituisce accettazione dei nuovi termini. Ogni Utente o Istruttore può cessare il proprio account in qualsiasi momento contattando la Piattaforma.",
        },
        {
          h: "8. Diritto applicabile e foro competente",
          p: "I presenti termini sono regolati dal diritto svizzero. Foro competente esclusivo è la sede della Piattaforma in Svizzera. Per i consumatori, restano applicabili le norme imperative svizzere o, ove più favorevoli, le norme dello Stato di residenza abituale del consumatore.",
        },
      ],
    },
    privacy: {
      title: "Informativa sulla Privacy",
      updated: "Ultimo aggiornamento: Febbraio 2026",
      sections: [
        {
          h: "1. Titolare del trattamento",
          p: "Titolare del trattamento è FitAgenda CH. Per qualsiasi richiesta in materia di protezione dei dati personali è possibile scrivere a: privacy@fitagenda.ch.",
        },
        {
          h: "2. Base normativa",
          p: "Il presente trattamento è conforme alla Legge federale svizzera sulla protezione dei dati (nLPD/FADP, in vigore dal 1° settembre 2023) e, ove applicabile a utenti residenti nell'UE, al Regolamento generale UE 2016/679 (GDPR).",
        },
        {
          h: "3. Dati raccolti",
          p: "Raccogliamo: (a) dati di registrazione (nome, email, password hashata con bcrypt, telefono se fornito); (b) dati di profilo istruttore (bio, certificazioni dichiarate); (c) dati di prenotazione (corsi prenotati, prezzi, date); (d) dati di pagamento (gestiti da Stripe, non memorizziamo numeri carta o IBAN); (e) recensioni e contenuti pubblicati; (f) log tecnici (indirizzo IP, user agent, timestamp accessi); (g) preferenze di lingua (tramite localStorage del browser).",
        },
        {
          h: "4. Finalità del trattamento",
          p: "I dati sono trattati per: (i) fornire il servizio (prenotazioni, pagamenti, comunicazioni); (ii) verifica dell'identità degli istruttori; (iii) gestione delle dispute e rimborsi; (iv) adempimenti contabili e fiscali svizzeri; (v) sicurezza informatica e prevenzione frodi; (vi) miglioramento del servizio in forma aggregata e anonima.",
        },
        {
          h: "5. Base giuridica",
          p: "Il trattamento si basa su: esecuzione del contratto (art. 31 cpv. 2 lett. a nLPD / art. 6.1.b GDPR), obblighi legali (art. 31 cpv. 2 lett. e nLPD / art. 6.1.c GDPR), legittimo interesse alla sicurezza della piattaforma, e consenso esplicito dove richiesto (cookie analitici, marketing).",
        },
        {
          h: "6. Conservazione",
          p: "I dati sono conservati per la durata necessaria alle finalità sopra indicate. I dati di prenotazione e pagamento sono conservati per 10 anni (art. 957a CO) per obblighi contabili svizzeri. I dati di profilo possono essere cancellati su richiesta dell'utente, fatto salvo l'obbligo di conservazione legale.",
        },
        {
          h: "7. Trasferimenti extra-CH/UE",
          p: "Alcuni fornitori (Stripe, Inc. - servizi di pagamento) possono trattare dati negli Stati Uniti. Tali trasferimenti avvengono tramite Standard Contractual Clauses approvate dalla Commissione UE e meccanismi equivalenti riconosciuti dal PFPDT svizzero.",
        },
        {
          h: "8. Diritti dell'interessato",
          p: "Hai diritto di: accedere ai tuoi dati, rettificarli, cancellarli (con i limiti di conservazione legale), limitarne o opporti al trattamento, ricevere copia portabile dei dati, revocare il consenso, presentare reclamo al PFPDT - Preposto federale alla protezione dei dati e alla trasparenza (https://www.edoeb.admin.ch) o alla competente Autorità UE.",
        },
        {
          h: "9. Sicurezza",
          p: "Adottiamo misure tecniche e organizzative adeguate: cifratura TLS in transito, hashing bcrypt delle password, accesso ai dati limitato a personale autorizzato, log di sicurezza, backup regolari. Nessuna trasmissione internet è però mai sicura al 100%; segnaliamo eventuali violazioni di dati significative entro 72 ore.",
        },
        {
          h: "10. Cookie e tracciamento",
          p: "Utilizziamo cookie tecnici essenziali (sessione, preferenza lingua) e, previo consenso esplicito, cookie analitici. Vedi la Cookie Policy per il dettaglio. Puoi gestire le preferenze in qualsiasi momento tramite le impostazioni del browser.",
        },
      ],
    },
    impressum: {
      title: "Impressum",
      updated: "Ultimo aggiornamento: Febbraio 2026",
      sections: [
        {
          h: "Operatore della piattaforma",
          p: "FitAgenda CH — beta version operata da: [INSERIRE RAGIONE SOCIALE]\nIndirizzo: [INSERIRE INDIRIZZO COMPLETO IN SVIZZERA]\nNumero IDI/UID: [INSERIRE SE REGISTRATO]\nIscrizione RC: [INSERIRE SE APPLICABILE]",
        },
        {
          h: "Contatti",
          p: "Email generale: info@fitagenda.ch\nEmail privacy: privacy@fitagenda.ch\nEmail supporto: support@fitagenda.ch",
        },
        {
          h: "Hosting",
          p: "La Piattaforma è ospitata su infrastruttura Emergent (Google Cloud Platform) — server localizzati nell'Unione Europea / Svizzera. I database sono gestiti tramite MongoDB.",
        },
        {
          h: "Responsabilità sui contenuti",
          p: "I contenuti pubblicati dagli Istruttori (descrizioni corsi, bio) sono di responsabilità diretta degli Istruttori stessi. La Piattaforma applica controlli di moderazione ragionevoli ma non si assume responsabilità sull'accuratezza dei contenuti di terzi.",
        },
        {
          h: "Diritti d'autore",
          p: "Salvo diversamente indicato, tutti i contenuti, marchi, loghi e codice della Piattaforma sono protetti dal diritto d'autore svizzero (LDA) e dalle convenzioni internazionali.",
        },
      ],
    },
    cookies: {
      title: "Cookie Policy",
      updated: "Ultimo aggiornamento: Febbraio 2026",
      sections: [
        {
          h: "Cosa sono i cookie",
          p: "I cookie sono piccoli file di testo che il sito memorizza sul tuo dispositivo durante la navigazione. Servono per far funzionare il sito, memorizzare preferenze e in alcuni casi raccogliere statistiche aggregate.",
        },
        {
          h: "Cookie utilizzati",
          p: "Cookie tecnici (essenziali, sempre attivi): token di autenticazione (httpOnly, secure), preferenza di lingua (localStorage), preferenza consenso cookie (localStorage).\n\nCookie di terze parti: Stripe (durante il checkout di pagamento, gestiti direttamente da Stripe secondo la sua privacy policy).\n\nAl momento la Piattaforma NON utilizza cookie analitici, di profilazione o di marketing.",
        },
        {
          h: "Gestione del consenso",
          p: "Il banner mostrato al primo accesso ti permette di accettare i cookie essenziali. Puoi sempre cancellare i cookie dalle impostazioni del tuo browser. La revoca del consenso ai cookie tecnici può impedire il corretto funzionamento del servizio (es. impossibilità di rimanere autenticato).",
        },
      ],
    },
  },
  de: {
    terms: {
      title: "Allgemeine Geschäftsbedingungen",
      updated: "Zuletzt aktualisiert: Februar 2026",
      sections: [
        {
          h: "1. Gegenstand der Dienstleistung",
          p: "FitAgenda CH (nachfolgend \"die Plattform\") ist ein digitaler Marktplatz, der Kunden (nachfolgend \"Nutzer\") mit selbstständigen Fitness-Trainern (nachfolgend \"Trainer\") in der Schweiz verbindet. Die Plattform agiert ausschliesslich als technologischer Vermittler und erbringt selbst keine sportlichen, trainings- oder medizinischen Leistungen.",
        },
        {
          h: "2. Vertragsverhältnis",
          p: "Der Vertrag über die Fitness-Dienstleistung kommt direkt zwischen Nutzer und Trainer zustande. Die Plattform ist nicht Vertragspartei und übernimmt keine Verantwortung für Qualität, Sicherheit, Eignung oder Ergebnis der Trainings. Jeder Trainer ist selbst für die Einhaltung der geltenden Schweizer Vorschriften verantwortlich (Bewilligungen, Berufshaftpflichtversicherung, kantonale und eidgenössische Sport- und Gesundheitsvorschriften).",
        },
        {
          h: "3. Zahlungen und Provisionen",
          p: "Zahlungen erfolgen über Stripe (mit TWINT) in Schweizer Franken (CHF). Die Plattform behält 10% Provision auf den Bruttopreis jeder Buchung ein; die restlichen 90% werden dem Trainer gutgeschrieben. Geschäftliche Rechnungen zwischen Nutzer und Trainer liegen in der alleinigen Verantwortung des Trainers (einschliesslich allfälliger MwSt-Pflicht ab CHF 100'000 Jahresumsatz gemäss Art. 10 MWSTG).",
        },
        {
          h: "4. Stornierungen, Rückerstattungen und Streitfälle",
          p: "Stornierungen des Trainers vor Kursbeginn führen zur vollen Rückerstattung an den Nutzer. Der Nutzer kann Probleme (Nichterscheinen des Trainers, mangelhafte Qualität, falscher Ort) innerhalb von 48 Stunden nach Kursende über die entsprechende Funktion melden. Die Administration prüft die Meldung und kann nach eigenem Ermessen eine vollständige oder teilweise Rückerstattung anordnen. Die Entscheidung der Plattform ist administrativ nicht anfechtbar; ordentlicher Rechtsweg bleibt vorbehalten.",
        },
        {
          h: "5. Bewertungen und Nutzerinhalte",
          p: "Bewertungen müssen wahrheitsgemäss und auf eigener Erfahrung basieren. Diffamierende, falsche oder diskriminierende Bewertungen können ohne Vorankündigung entfernt werden. Der Trainer kann die Entfernung offensichtlich rechtswidriger Bewertungen verlangen. Die Plattform haftet nicht für die Richtigkeit der von Trainern veröffentlichten Inhalte (Kursbeschreibungen, Bio, Zertifikate).",
        },
        {
          h: "6. Haftungsbeschränkung",
          p: "Soweit nach Schweizer Recht zulässig, schliesst die Plattform jegliche Haftung aus für: (a) während oder infolge der Kurse erlittene Verletzungen oder Sach-/Personenschäden; (b) Verhalten oder Unterlassungen der Trainer; (c) medizinische Eignung des Nutzers zur sportlichen Betätigung (der Nutzer ist verpflichtet, vor Aufnahme eines Trainingsprogramms einen Arzt zu konsultieren); (d) vorübergehende Dienstunterbrechungen, Störungen der Zahlungssysteme, Datenverlust durch höhere Gewalt. Die Haftung für Vorsatz oder grobe Fahrlässigkeit kann gemäss Art. 100 OR nicht ausgeschlossen werden.",
        },
        {
          h: "7. Änderungen und Beendigung",
          p: "Die Plattform kann diese Bedingungen jederzeit anpassen. Änderungen werden per E-Mail oder In-App-Hinweis kommuniziert. Die fortgesetzte Nutzung gilt als Annahme der neuen Bedingungen. Nutzer und Trainer können ihr Konto jederzeit kündigen, indem sie die Plattform kontaktieren.",
        },
        {
          h: "8. Anwendbares Recht und Gerichtsstand",
          p: "Es gilt Schweizer Recht. Ausschliesslicher Gerichtsstand ist der Sitz der Plattform in der Schweiz. Zwingende schweizerische Konsumentenschutzbestimmungen oder günstigere Bestimmungen am gewöhnlichen Aufenthaltsort des Konsumenten bleiben vorbehalten.",
        },
      ],
    },
    privacy: {
      title: "Datenschutzerklärung",
      updated: "Zuletzt aktualisiert: Februar 2026",
      sections: [
        {
          h: "1. Verantwortlicher",
          p: "Verantwortlich für die Datenverarbeitung ist FitAgenda CH. Anfragen zum Datenschutz: privacy@fitagenda.ch.",
        },
        {
          h: "2. Rechtsgrundlage",
          p: "Diese Verarbeitung entspricht dem Schweizer Datenschutzgesetz (nDSG/FADP, in Kraft seit 1. September 2023) und, soweit auf in der EU ansässige Nutzer anwendbar, der EU-Verordnung 2016/679 (DSGVO).",
        },
        {
          h: "3. Erhobene Daten",
          p: "Wir erheben: (a) Registrierungsdaten (Name, E-Mail, mit bcrypt gehashtes Passwort, Telefon falls angegeben); (b) Trainerprofildaten (Bio, angegebene Zertifikate); (c) Buchungsdaten (gebuchte Kurse, Preise, Daten); (d) Zahlungsdaten (über Stripe, wir speichern keine Kartennummern oder IBAN); (e) Bewertungen und veröffentlichte Inhalte; (f) technische Logs (IP-Adresse, User Agent, Zugriffs-Zeitstempel); (g) Spracheinstellung (im localStorage des Browsers).",
        },
        {
          h: "4. Zwecke",
          p: "Die Daten werden verarbeitet zur: (i) Bereitstellung des Dienstes (Buchungen, Zahlungen, Kommunikation); (ii) Identitätsprüfung der Trainer; (iii) Bearbeitung von Streitfällen und Rückerstattungen; (iv) Erfüllung schweizerischer Buchhaltungs- und Steuerpflichten; (v) IT-Sicherheit und Betrugsprävention; (vi) anonymisierte aggregierte Dienstverbesserung.",
        },
        {
          h: "5. Rechtsgrundlage der Verarbeitung",
          p: "Die Verarbeitung stützt sich auf: Vertragserfüllung (Art. 31 Abs. 2 lit. a nDSG / Art. 6.1.b DSGVO), gesetzliche Pflichten (Art. 31 Abs. 2 lit. e nDSG / Art. 6.1.c DSGVO), berechtigtes Interesse an Plattformsicherheit, und ausdrückliche Einwilligung wo erforderlich (Analytics-Cookies, Marketing).",
        },
        {
          h: "6. Aufbewahrung",
          p: "Die Daten werden für die zur Zweckerfüllung erforderliche Dauer aufbewahrt. Buchungs- und Zahlungsdaten werden gemäss Art. 957a OR 10 Jahre für die schweizerische Buchhaltung aufbewahrt. Profildaten können auf Anfrage gelöscht werden, unter Vorbehalt gesetzlicher Aufbewahrungspflichten.",
        },
        {
          h: "7. Datenübermittlung ins Ausland",
          p: "Einige Dienstleister (Stripe, Inc. - Zahlungsdienste) können Daten in den USA verarbeiten. Diese Übermittlungen erfolgen über Standardvertragsklauseln der EU-Kommission und vom EDÖB anerkannte gleichwertige Mechanismen.",
        },
        {
          h: "8. Rechte der betroffenen Person",
          p: "Du hast das Recht auf: Auskunft, Berichtigung, Löschung (im Rahmen gesetzlicher Aufbewahrung), Einschränkung oder Widerspruch der Verarbeitung, Datenportabilität, Widerruf der Einwilligung, Beschwerde beim EDÖB - Eidgenössischer Datenschutz- und Öffentlichkeitsbeauftragter (https://www.edoeb.admin.ch) oder bei der zuständigen EU-Aufsichtsbehörde.",
        },
        {
          h: "9. Sicherheit",
          p: "Wir setzen angemessene technische und organisatorische Massnahmen ein: TLS-Verschlüsselung in Transit, bcrypt-Hashing der Passwörter, Zugriffsbeschränkung auf autorisiertes Personal, Sicherheitsprotokolle, regelmässige Backups. Keine Internetübertragung ist zu 100% sicher; signifikante Datenschutzverletzungen melden wir innerhalb von 72 Stunden.",
        },
        {
          h: "10. Cookies und Tracking",
          p: "Wir verwenden technisch essenzielle Cookies (Session, Sprachpräferenz) und, bei ausdrücklicher Einwilligung, Analytics-Cookies. Details in der Cookie Policy. Die Präferenzen können jederzeit in den Browser-Einstellungen verwaltet werden.",
        },
      ],
    },
    impressum: {
      title: "Impressum",
      updated: "Zuletzt aktualisiert: Februar 2026",
      sections: [
        {
          h: "Plattformbetreiber",
          p: "FitAgenda CH — Beta-Version betrieben von: [FIRMENBEZEICHNUNG EINTRAGEN]\nAdresse: [VOLLSTÄNDIGE SCHWEIZER ADRESSE EINTRAGEN]\nUID-Nummer: [FALLS REGISTRIERT EINTRAGEN]\nHandelsregister-Eintrag: [FALLS ZUTREFFEND EINTRAGEN]",
        },
        {
          h: "Kontakt",
          p: "Allgemeine E-Mail: info@fitagenda.ch\nDatenschutz-E-Mail: privacy@fitagenda.ch\nSupport-E-Mail: support@fitagenda.ch",
        },
        {
          h: "Hosting",
          p: "Die Plattform wird auf der Emergent-Infrastruktur (Google Cloud Platform) gehostet — Server in der EU/Schweiz. Datenbanken werden über MongoDB verwaltet.",
        },
        {
          h: "Inhaltsverantwortung",
          p: "Die von Trainern veröffentlichten Inhalte (Kursbeschreibungen, Bio) liegen in der direkten Verantwortung der jeweiligen Trainer. Die Plattform führt angemessene Moderationskontrollen durch, übernimmt jedoch keine Verantwortung für die Richtigkeit von Drittinhalten.",
        },
        {
          h: "Urheberrecht",
          p: "Sofern nicht anders angegeben, sind alle Inhalte, Marken, Logos und der Code der Plattform durch das schweizerische Urheberrechtsgesetz (URG) und internationale Konventionen geschützt.",
        },
      ],
    },
    cookies: {
      title: "Cookie-Richtlinie",
      updated: "Zuletzt aktualisiert: Februar 2026",
      sections: [
        {
          h: "Was sind Cookies",
          p: "Cookies sind kleine Textdateien, die beim Besuch der Website auf deinem Gerät gespeichert werden. Sie dienen dem Betrieb der Website, dem Speichern von Präferenzen und in einigen Fällen der Erhebung aggregierter Statistiken.",
        },
        {
          h: "Verwendete Cookies",
          p: "Technische Cookies (essenziell, immer aktiv): Authentifizierungs-Token (httpOnly, secure), Sprachpräferenz (localStorage), Cookie-Einwilligung (localStorage).\n\nCookies von Drittanbietern: Stripe (während des Zahlungs-Checkouts, direkt von Stripe gemäss seiner Datenschutzrichtlinie verwaltet).\n\nDie Plattform verwendet derzeit KEINE Analytics-, Profiling- oder Marketing-Cookies.",
        },
        {
          h: "Verwaltung der Einwilligung",
          p: "Das beim ersten Besuch angezeigte Banner ermöglicht die Akzeptanz essenzieller Cookies. Du kannst Cookies jederzeit in den Browser-Einstellungen löschen. Der Widerruf der Einwilligung zu technischen Cookies kann den korrekten Betrieb des Dienstes verhindern (z.B. keine dauerhafte Anmeldung möglich).",
        },
      ],
    },
  },
  fr: {
    terms: {
      title: "Conditions Générales",
      updated: "Dernière mise à jour : février 2026",
      sections: [
        {
          h: "1. Objet du service",
          p: "FitAgenda CH (ci-après \"la Plateforme\") est une place de marché numérique qui met en relation des clients (ci-après \"Utilisateurs\") avec des coachs de fitness indépendants (ci-après \"Coachs\") actifs sur le territoire suisse. La Plateforme agit exclusivement en tant qu'intermédiaire technologique et ne fournit elle-même aucun service sportif, d'entraînement ou médical.",
        },
        {
          h: "2. Nature de la relation contractuelle",
          p: "Le contrat de prestation du service de fitness est conclu directement entre l'Utilisateur et le Coach. La Plateforme n'est pas partie à ce contrat et n'assume aucune responsabilité quant à la qualité, la sécurité, l'aptitude ou le résultat des séances d'entraînement. Chaque Coach est personnellement responsable du respect de la réglementation suisse applicable (autorisations, assurance responsabilité civile professionnelle, normes cantonales et fédérales en matière sportive et sanitaire).",
        },
        {
          h: "3. Paiements et commissions",
          p: "Les paiements s'effectuent via Stripe (méthode TWINT) en francs suisses (CHF). La Plateforme retient une commission de 10% sur le prix brut de chaque réservation ; les 90% restants sont versés au Coach. Les factures commerciales entre l'Utilisateur et le Coach relèvent de la responsabilité exclusive du Coach (y compris l'éventuel assujettissement à la TVA dès CHF 100'000 de chiffre d'affaires annuel selon l'art. 10 LTVA).",
        },
        {
          h: "4. Annulations, remboursements et litiges",
          p: "Les annulations effectuées par le Coach avant le début du cours entraînent le remboursement intégral à l'Utilisateur. L'Utilisateur peut signaler des problèmes (non-présentation du Coach, qualité insuffisante, lieu erroné) dans les 48 heures suivant la fin du cours via la fonction dédiée. L'administration de la Plateforme évalue le signalement et peut décider d'un remboursement total ou partiel à sa discrétion. La décision de la Plateforme n'est pas susceptible de recours administratif, sous réserve des voies de droit ordinaires.",
        },
        {
          h: "5. Avis et contenus utilisateur",
          p: "Les avis doivent être véridiques et fondés sur une expérience directe. Les avis diffamatoires, faux ou discriminatoires peuvent être supprimés sans préavis. Le Coach peut demander à la Plateforme de retirer un avis manifestement illicite. La Plateforme ne se porte pas garante de la véracité des contenus publiés par les Coachs (descriptions des cours, bio, certifications déclarées).",
        },
        {
          h: "6. Limitation de responsabilité",
          p: "Dans toute la mesure permise par le droit suisse, la Plateforme exclut toute responsabilité pour : (a) les blessures ou dommages physiques ou matériels survenus pendant ou à la suite des cours réservés ; (b) la conduite ou les omissions des Coachs ; (c) l'aptitude médicale de l'Utilisateur à la pratique sportive (il appartient à l'Utilisateur de consulter un médecin avant d'entamer un programme d'activité physique) ; (d) les interruptions temporaires du service, les dysfonctionnements des systèmes de paiement, la perte de données pour cause de force majeure. La responsabilité pour dol ou faute grave ne peut être exclue conformément à l'art. 100 CO.",
        },
        {
          h: "7. Modifications et résiliation",
          p: "La Plateforme peut modifier les présentes conditions à tout moment, en informant par e-mail ou par notification in-app. La poursuite de l'utilisation du service vaut acceptation des nouvelles conditions. Tout Utilisateur ou Coach peut résilier son compte à tout moment en contactant la Plateforme.",
        },
        {
          h: "8. Droit applicable et for",
          p: "Les présentes conditions sont régies par le droit suisse. For exclusif au siège de la Plateforme en Suisse. Pour les consommateurs, les dispositions impératives suisses ou, si elles sont plus favorables, celles du pays de résidence habituelle du consommateur, restent applicables.",
        },
      ],
    },
    privacy: {
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : février 2026",
      sections: [
        {
          h: "1. Responsable du traitement",
          p: "Le responsable du traitement est FitAgenda CH. Pour toute demande en matière de protection des données : privacy@fitagenda.ch.",
        },
        {
          h: "2. Base légale",
          p: "Le présent traitement est conforme à la Loi fédérale suisse sur la protection des données (LPD/FADP, en vigueur depuis le 1er septembre 2023) et, lorsque applicable aux utilisateurs résidant dans l'UE, au Règlement général UE 2016/679 (RGPD).",
        },
        {
          h: "3. Données collectées",
          p: "Nous collectons : (a) données d'inscription (nom, e-mail, mot de passe haché bcrypt, téléphone si fourni) ; (b) données de profil coach (bio, certifications déclarées) ; (c) données de réservation (cours réservés, prix, dates) ; (d) données de paiement (gérées par Stripe, nous ne stockons pas les numéros de carte ni l'IBAN) ; (e) avis et contenus publiés ; (f) logs techniques (adresse IP, user agent, horodatage des accès) ; (g) préférence linguistique (via localStorage du navigateur).",
        },
        {
          h: "4. Finalités du traitement",
          p: "Les données sont traitées afin de : (i) fournir le service (réservations, paiements, communications) ; (ii) vérifier l'identité des coachs ; (iii) gérer les litiges et les remboursements ; (iv) respecter les obligations comptables et fiscales suisses ; (v) assurer la sécurité informatique et prévenir la fraude ; (vi) améliorer le service de manière agrégée et anonyme.",
        },
        {
          h: "5. Base juridique",
          p: "Le traitement repose sur : l'exécution du contrat (art. 31 al. 2 let. a LPD / art. 6.1.b RGPD), les obligations légales (art. 31 al. 2 let. e LPD / art. 6.1.c RGPD), l'intérêt légitime à la sécurité de la plateforme, et le consentement explicite lorsque requis (cookies analytiques, marketing).",
        },
        {
          h: "6. Conservation",
          p: "Les données sont conservées le temps nécessaire à la réalisation des finalités. Les données de réservation et de paiement sont conservées pendant 10 ans (art. 957a CO) au titre des obligations comptables suisses. Les données de profil peuvent être supprimées à la demande de l'utilisateur, sous réserve des obligations légales de conservation.",
        },
        {
          h: "7. Transferts hors CH/UE",
          p: "Certains prestataires (Stripe, Inc. – services de paiement) peuvent traiter des données aux États-Unis. Ces transferts s'effectuent via les Clauses contractuelles types approuvées par la Commission UE et les mécanismes équivalents reconnus par le PFPDT suisse.",
        },
        {
          h: "8. Droits de la personne concernée",
          p: "Tu as le droit de : accéder à tes données, les rectifier, les supprimer (dans la limite des obligations légales), en limiter ou t'opposer au traitement, recevoir une copie portable, retirer ton consentement, déposer une réclamation auprès du PFPDT – Préposé fédéral à la protection des données et à la transparence (https://www.edoeb.admin.ch) ou auprès de l'autorité UE compétente.",
        },
        {
          h: "9. Sécurité",
          p: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées : chiffrement TLS en transit, hachage bcrypt des mots de passe, accès aux données limité au personnel autorisé, journaux de sécurité, sauvegardes régulières. Aucune transmission internet n'est cependant sûre à 100% ; nous notifions toute violation significative dans les 72 heures.",
        },
        {
          h: "10. Cookies et traçage",
          p: "Nous utilisons des cookies techniques essentiels (session, préférence linguistique) et, sous réserve d'un consentement explicite, des cookies analytiques. Voir la Politique cookies pour les détails. Tu peux gérer tes préférences à tout moment via les paramètres du navigateur.",
        },
      ],
    },
    impressum: {
      title: "Mentions légales",
      updated: "Dernière mise à jour : février 2026",
      sections: [
        {
          h: "Exploitant de la plateforme",
          p: "FitAgenda CH — version bêta exploitée par : [INSÉRER RAISON SOCIALE]\nAdresse : [INSÉRER ADRESSE COMPLÈTE EN SUISSE]\nNuméro IDE/UID : [INSÉRER SI ENREGISTRÉ]\nInscription RC : [INSÉRER SI APPLICABLE]",
        },
        {
          h: "Contacts",
          p: "E-mail général : info@fitagenda.ch\nE-mail confidentialité : privacy@fitagenda.ch\nE-mail support : support@fitagenda.ch",
        },
        {
          h: "Hébergement",
          p: "La Plateforme est hébergée sur l'infrastructure Emergent (Google Cloud Platform) — serveurs situés dans l'Union européenne / Suisse. Les bases de données sont gérées via MongoDB.",
        },
        {
          h: "Responsabilité du contenu",
          p: "Les contenus publiés par les Coachs (descriptions de cours, bio) relèvent de la responsabilité directe des Coachs eux-mêmes. La Plateforme applique des contrôles de modération raisonnables mais n'assume aucune responsabilité quant à l'exactitude des contenus de tiers.",
        },
        {
          h: "Droits d'auteur",
          p: "Sauf indication contraire, tous les contenus, marques, logos et code de la Plateforme sont protégés par le droit d'auteur suisse (LDA) et les conventions internationales.",
        },
      ],
    },
    cookies: {
      title: "Politique cookies",
      updated: "Dernière mise à jour : février 2026",
      sections: [
        {
          h: "Que sont les cookies",
          p: "Les cookies sont de petits fichiers texte que le site stocke sur ton appareil pendant la navigation. Ils servent à faire fonctionner le site, à mémoriser des préférences et, dans certains cas, à recueillir des statistiques agrégées.",
        },
        {
          h: "Cookies utilisés",
          p: "Cookies techniques (essentiels, toujours actifs) : token d'authentification (httpOnly, secure), préférence linguistique (localStorage), préférence de consentement cookies (localStorage).\n\nCookies tiers : Stripe (pendant le checkout de paiement, gérés directement par Stripe selon sa politique de confidentialité).\n\nLa Plateforme n'utilise actuellement AUCUN cookie analytique, de profilage ou de marketing.",
        },
        {
          h: "Gestion du consentement",
          p: "La bannière affichée lors du premier accès te permet d'accepter les cookies essentiels. Tu peux à tout moment supprimer les cookies depuis les paramètres de ton navigateur. Le retrait du consentement aux cookies techniques peut empêcher le bon fonctionnement du service (par ex. impossibilité de rester connecté).",
        },
      ],
    },
  },
};
